import Payouts from '../../../../api/api-payouts';
import * as types from '../constants/action-types';

const fetchPayoutsRequest = (listingToFetch) => {
  return {
    type: types.PAYOUTS_FETCH_REQUEST,
    listingToFetch
  };
};

const fetchPayoutsSuccess = (data) => {
  return {
    type: types.PAYOUTS_FETCH_SUCCESS,
    data
  };
};

const fetchPendingPayoutsSuccess = (pendingPayoutsData) => {
  return {
    type: types.PAYOUTS_PENDING_FETCH_SUCCESS,
    pendingPayoutsData
  };
};

const fetchPayoutsFailure = (fetchError) => {
  return {
    type: types.PAYOUTS_FETCH_FAILURE,
    fetchError
  };
};

export const submitCsv = (csvFetching) => {
  return {
    type: types.CSV_FETCHING,
    csvFetching
  };
};

export const fetchPayouts = (ssoId, token, query) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchPayoutsRequest());
      Payouts.read(ssoId, token, query, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchPayoutsSuccess(response));

          return resolve(response);
        }
        const error = (response || {}).error;
        dispatch(fetchPayoutsFailure(error));
        return reject(error);
      });
    });
  };
};

export const fetchPayoutsCSV = (ssoId, token, query) => {
  return () => {
    return new Promise((resolve, reject) => {
      Payouts.read(ssoId, token, query, (response) => {
        if (200 === response.statusCode) {
          return resolve(response);
        }
        const error = (response || {}).error;
        return reject(error);
      });
    });
  };
};

export const fetchPendingPayouts = (ssoId, token, query) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchPayoutsRequest());
      Payouts.read(ssoId, token, `/expected?states=SCHEDULED&states=PROCESSING${query}`, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchPendingPayoutsSuccess(response));

          return resolve(response);
        }
        const error = (response || {}).error;
        dispatch(fetchPayoutsFailure(error));
        return reject(error);
      });
    });
  };
};
